// import InputField from "components/fields/InputField";
// import { FcGoogle } from "react-icons/fc";
// import Checkbox from "components/checkbox";
import { useState } from "react";
import useForgotPasswordFormContext from "hooks/useForgotPasswordFormContext";
import ForgotPasswordFormInputs from "./ForgotPassword/ForgotPasswordFormInputs";
import { useMutation } from "@apollo/client"
import { CREATE_USER_MUTATION } from "graphql/auth/mutations"
import ErrorAlert from "components/ErrorAlert";
import SuccessAlert from "components/SuccessAlert";
import { Link, useNavigate } from "react-router-dom";
import { GENERATE_OTP_MUTATION } from "graphql/users/mutations";
import { VERIFY_OTP_MUTATION } from "graphql/users/mutations";
import { UPDATE_PASSWORD_MUTATION } from "graphql/users/mutations";
import Loader from "components/Loader";

export default function ForgotPassword() {

    const navigate = useNavigate()

    const [createUser] = useMutation(CREATE_USER_MUTATION);
    const [generateOTPMuation] = useMutation(GENERATE_OTP_MUTATION);
    const [verifyOTPMutation] = useMutation(VERIFY_OTP_MUTATION);
    const [updatePasswordMutation] = useMutation(UPDATE_PASSWORD_MUTATION);

    const {
        // page,
        setPage,
        data,
        // title,
        canSubmit,
        canSubmitSetPassword,
        // disablePrev,
        // disableNext,
        // prevHide,
        nextHide,
        submitPasswordHide,
        submitHide
    } = useForgotPasswordFormContext()

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [otpSent, setOtpSent] = useState(false);

    const handlePrev = () => setPage(prev => prev - 1)

    const handleNext = () => {
        setPage(prev => prev + 1)
    }

    const generateOTP = e => {
        e.preventDefault();
        setLoaderOpen(true);
        setError('');
        setSuccess('');
        setOtpSent(false);
        
        generateOTPMuation({
            variables: {
                email: data.email
            }
        })
            .then((response) => {
                if (response.data.generateOTP) {
                    setPage(prev => prev + 1)
                    setLoaderOpen(false);
                    setOtpSent(true);
                    setSuccess(`OTP has been sent to ${data.email}. Please check your inbox and spam folder. The OTP will expire in 10 minutes.`);
                } else {
                    setLoaderOpen(false);
                    throw ("Something went Wrong")
                }
            })
            .catch((error) => {
                console.error("Error Encountered: ", error);
                if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                    const errorMessage = error.graphQLErrors[0]?.message;
                    if (errorMessage) {
                        setLoaderOpen(false);
                        setError(errorMessage);
                    } else {
                        setLoaderOpen(false);
                        setError('Failed to send OTP. Please try again.');
                    }
                } else {
                    setError(error.message || 'Network error. Please check your connection.');
                    setLoaderOpen(false);
                }
            })
    }

    const submitOTP = e => {
        e.preventDefault();
        setLoaderOpen(true);
        setError('');
        setSuccess('');
        
        verifyOTPMutation({
            variables: {
                email: data.email,
                otp: data.otp
            }
        })
            .then((response) => {
                if (response.data.verifyOTP) {
                    setPage(prev => prev + 1);
                    setLoaderOpen(false);
                    setSuccess('OTP verified successfully! Please set your new password.');
                } else {
                    setError("OTP Incorrect or Expired. Please click 'Resend OTP' to get a new code.")
                    setLoaderOpen(false)
                    throw ({ "message": "OTP Incorrect or Expired. Please regenerate." })
                }
            })
            .catch((error) => {
                console.error("Error Encountered: ", error);
                if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                    const errorMessage = error.graphQLErrors[0]?.message;
                    if (errorMessage) {
                        setError(errorMessage);
                        setLoaderOpen(false);
                    } else {
                        setError('Failed to verify OTP. Please try again or request a new OTP.');
                        setLoaderOpen(false);
                    }
                } else {
                    setError(error.message || 'Network error. Please check your connection.');
                    setLoaderOpen(false);
                }
            })
    }

    const submitSetPassword = (e) => {
        e.preventDefault();
        
        if (!(data.password === data.confirmPassword)) {
            setError('Password and Confirm Password fields must match.');
            return;
        }
        
        if (data.password.length < 8) {
            setError('Password must be at least 8 characters long.');
            return;
        }
        
        setLoaderOpen(true);
        setError('');
        setSuccess('');

        updatePasswordMutation({
            variables: {
                email: data.email,
                newPassword: data.password
            }
        })
            .then(response => {
                if (response.data.updatePassword) {
                    setLoaderOpen(false);
                    setSuccess('Password updated successfully! Redirecting to login...');
                    setTimeout(() => {
                        navigate('/auth/sign-in');
                    }, 2000);
                }
            })
            .catch(error => {
                console.error("Error Encountered: ", error);
                if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                    const errorMessage = error.graphQLErrors[0]?.message;
                    if (errorMessage) {
                        setLoaderOpen(false);
                        setError(errorMessage);
                    } else {
                        setLoaderOpen(false);
                        setError('Failed to update password. Please try again.');
                    }
                } else {
                    setError(error.message || 'Network error. Please check your connection.');
                    setLoaderOpen(false);
                }
            })
    }

    const onClose = () => {
        setError('');
    }

    const onSuccessClose = () => {
        setSuccess('');
    }

    return (
        <form className="form flex-col">

            {error && <ErrorAlert message={error} onClose={onClose} />}
            {success && <SuccessAlert message={success} onClose={onSuccessClose} />}

            <Loader loaderOpen={loaderOpen} setLoaderOpen={setLoaderOpen} />

            {/* <header className="form-header">
                <h2>{title[page]}</h2>

                <div className="button-container">

                <button type="button" className={`button ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>Prev</button>

                <button type="button" className={`button ${nextHide}`} onClick={handleNext} disabled={disableNext}>Next</button>

                <button type="submit" className={`button ${submitHide}`} disabled={!canSubmit}>Submit</button>
                </div>
            </header> */}
            <div className="flex flex-col-reverse lg:flex-row items-center justify-between w-full">
                <div className="w-full max-w-full flex-col items-center lg:max-w-[420px] m-8">
                    <ForgotPasswordFormInputs />
                    <div className="mt-4">
                        <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
                            Already Have an Acccount?
                        </span>
                        <Link
                            to={"/auth/sign-in"}
                            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
                        >
                            Sign In
                        </Link>
                    </div>
                    <div className="button-container gap-4 w-full max-w-full flex items-center lg:pl-0 xl:max-w-[420px]">

                        {/* <button
                            className={`
                                linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 
                                ${prevHide}
                            `}
                            type="button"
                            onClick={handlePrev}
                            disabled={disablePrev}
                            >
                            Prev
                            </button> */}

                        <button
                            className={`
                                linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200
                                ${nextHide}
                            `}
                            onClick={generateOTP}
                        // disabled={disableNext}
                        >
                            Generate OTP
                        </button>

                        <button
                            className={`
                                linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200
                                ${submitHide}
                            `}
                            onClick={submitOTP}
                        // disabled={!canSubmit}
                        >
                            Submit OTP
                        </button>

                        <button
                            className={`
                        linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200
                        ${submitPasswordHide}
                    `}
                            onClick={submitSetPassword}
                        // disabled={!canSubmitSetPassword}
                        >
                            Create New Password
                        </button>
                        {/* <button type="button" className={`button ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>Prev</button>

        <button type="button" className={`button ${nextHide}`} onClick={handleNext} disabled={disableNext}>Next</button>

        <button type="submit" className={`button ${submitHide}`} disabled={!canSubmit}>Submit</button> */}
                    </div>
                </div>
                <div>
                    <img src="/Images/login_page.png" />
                </div>
            </div>
        </form>
    );
}
